<template>
    <MyModal :name="modalName" :title="title" :isRightModal="true" :animation="'modal-right'">
        <div class="content-modal" v-html="content" />
    </MyModal>
</template>

<script>
import VueTypes, { nullable } from 'vue-types'
import { MODAL_CONTENT } from '~/themes/novaporta/consts/modals'

export default {
    name: 'ModalContent',
    props: {
        title: VueTypes.string.def(''),
        content: VueTypes.string.isRequired,
    },
    data() {
        return {
            modalName: MODAL_CONTENT,
        };
    },
    components: {
        MyModal: () => import('@/themes/novaporta/components/ui/MyModal')
    },
};
</script>

<style lang="scss">
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>
